import { render, staticRenderFns } from "./CustomerDocument.vue?vue&type=template&id=3d9ca760&"
import script from "./CustomerDocument.vue?vue&type=script&lang=js&"
export * from "./CustomerDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports